// extracted by css-extract-rspack-plugin
export default {"title":"product-detail-fragment__FriendsDiscountSelect_title__w-TvS","ios15Fix":"product-detail-fragment__FriendsDiscountSelect_ios15Fix__5h9+g"};